require('../../modules/es6.array.is-array');
module.exports = require('../../modules/_core').Array.isArray;



/*****************
 ** WEBPACK FOOTER
 ** ../~/core-js/fn/array/is-array.js
 ** module id = 123
 ** module chunks = 10
 **/